<template>
  <div>
    <a class="pl-1" role="button" @click.prevent="onClickDelete">{{
      trans.get("strings.observations.edit.delete")
    }}</a>
    <delete-observation-modal
      v-if="showModal"
      @close-modal="onCancel"
      @delete-observation="deleteObservation"
    ></delete-observation-modal>
  </div>
</template>

<script>
import DeleteObservationModal from "./DeleteObservationModal";

export default {
  props: {
    observation_id: {
      type: Number,
      required: true,
    },
    go_to_url: {
      type: String,
    },
  },

  components: {
    "delete-observation-modal": DeleteObservationModal,
  },

  data: () => ({
    showModal: false,
  }),

  mounted() {},

  methods: {
    onCancel() {
      this.showModal = false;
    },

    onClickDelete() {
      this.showModal = true;
    },

    deleteObservation() {
      let vm = this;

      axios
        .delete(`/observations/${this.observation_id}`)
        .then(function (response) {
          $(location).attr("href", vm.go_to_url);
        })
        .catch(function (error) {
          alert("There was an error deleting this observation.");
        });
    },
  },
};
</script>
